import { isDocumentFile } from './document-file'
import { isDocumentRevision } from './document-revision';
import { isShareBaseDocument } from './sharebase-document';
import { isShareBaseFolder } from './sharebase-folder';
import { isShareBaseLibrary } from './sharebase-library';
import { isTrash } from './phoenix-trash-item';
export type AsyncOpStatus = 'None' | 'Initialized' | 'Processing' | 'Succeeded' | 'Failed' | 'Deleted';    
export interface ShareBaseItem {
    LibraryId: number;
    DateCreated: string | Date;
    Embedded: any;
    Links: any;
    AsyncPurgeOpStatus?:AsyncOpStatus;
    IsFavorite?: boolean;
}

export type ObjectTypeName = 'Document' | 'Folder' | 'Library';
// assign values explicitly to ensure a bit flag
export enum ItemType {
    None = -1,
    Document = 0x0001,
    Folder = 0x0002,
    Library = 0x0004,
    All = ItemType.Document | ItemType.Folder | ItemType.Library
}

export function isPurgedOrPurging(item: ShareBaseItem){
    return item.AsyncPurgeOpStatus === 'Initialized' || item.AsyncPurgeOpStatus === 'Processing' || item.AsyncPurgeOpStatus === 'Succeeded';
}

export function toItemCode(item:ShareBaseItem) {
    let type = ItemType.None;

    if(item){
        if(isShareBaseDocument(item)){
            type = ItemType.Document;
        }
        else if(isShareBaseFolder(item)){
            type = ItemType.Folder;
        }
        else if(isShareBaseLibrary(item)){
            type = ItemType.Library;
        }
    }

    return type;
}

function isShareBaseItem(obj):obj is ShareBaseItem {
    return angular.isDefined(obj.DateCreated) 
        && angular.isDefined(obj.Owner)
        && angular.isDefined(obj.LibraryId);
}

export const pxItemTypeGuards = {
    isDocumentFile,
    isDocumentRevision,
    isShareBaseItem,
    isShareBaseDocument,
    isShareBaseFolder,
    isShareBaseLibrary,
    isTrash
};


// WEBPACK FOOTER //
// ./src/phoenix/domain/sharebase-item.ts